import React from 'react';
import { Carousel as CarouselLib } from 'react-responsive-carousel';
import { STATIC_PREFIX } from '../../constants/staticPrefix';

const Carousel = ({ images, onImageClick }) => {
  if (images?.length === 0) {
    return (
      <img
        src={`${STATIC_PREFIX}/static/images/logo.png`}
        style={{ height: '48px', margin: 'auto' }}
        alt="BitTeam"
      />
    );
  }

  return (
    <CarouselLib
      className="product__carousel"
      showIndicators
      showArrows
      labels={{
        rightArrow: '->',
        leftArrow: '<-',
      }}
    >
      {images && images.map((image, index) => (
        <div key={image.id} onClick={onImageClick(index)}>
          <img
            src={image.thumb}
            alt=""
          />
        </div>
      ))}
    </CarouselLib>
  );
};

export default Carousel;
